import { TFinanceDetails } from '../../apis/finance/finance.interfaces';
import { mockUserAction } from '../users/userAction';

export const mockFinanceDetails: TFinanceDetails = {
  basic_details: {
    _id: 'fin-123',
    amount: 50000,
    paid_amount: 25000,
    currency_code: 'INR',
    description: 'Tuition Fee - Term 1 for Academic Year 2025-2026',
    fine: 500,
    fine_currency_code: 'INR',
    is_credit: false,
    academic_year: 2025,
    due_date: new Date('2025-12-31T00:00:00.000Z'),
    payment_mode: 'online',
    status: 'partial',
    type: 'fee_tuition',
  },
  institute: {
    _id: 'inst-789',
    name: 'Delhi Public School',
  },
  counter_ref: {
    counter_ref_type: 'fee_schedule',
    counter_ref_id: 'schedule-456',
    counter_ref_details: {
      payable_amount: 50000,
      status: 'active',
      due_date: '2025-12-31T00:00:00.000Z',
      description: 'Monthly tuition fee schedule for academic year 2025-2026',
    },
  },
  students: [
    {
      _id: 'student-123',
      first_name: 'Priya',
      last_name: 'Sharma',
      enrollment_date: new Date('2025-01-15T00:00:00.000Z'),
      academic_year: 2025,
    },
    {
      _id: 'student-124',
      first_name: 'Arjun',
      last_name: 'Kumar',
      enrollment_date: new Date('2025-01-15T00:00:00.000Z'),
      academic_year: 2025,
    },
  ],
  fee_schedule: {
    _id: 'schedule-456',
    original_amount: 50000,
    adjusted_amount: 50000,
    payable_amount: 50000,
    status: 'active',
  },
  documents: [
    {
      _id: 'doc-789',
      name: 'Payment Receipt - Priya Sharma',
      document_type: 'receipt',
      status: 'verified',
      file_key: 'finance/fin-123/receipt-priya-sharma.pdf',
    },
    {
      _id: 'doc-790',
      name: 'Fee Invoice - Term 1',
      document_type: 'invoice',
      status: 'verified',
      file_key: 'finance/fin-123/invoice-term1.pdf',
    },
  ],
  action: {
    created_at: new Date('2025-11-01T10:00:00.000Z'),
    created_by: mockUserAction.userId,
    updated_at: new Date('2025-11-15T14:30:00.000Z'),
    updated_by: mockUserAction.userId,
  },
};
